import { Injectable } from '@angular/core';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';

@Injectable()
export class TableBookingModalService {
  constructor(private _modalService: NzModalService) {}

  async openTimeConfigModal(slotData: any): Promise<NzModalRef<any>>  {
    const { TableBookingTimeConfigModalComponent } = await import(
      /* webpackPrefetch: true */ '../modal/time-config-modal/table-booking-time-config-modal.component'
    );
    return this._modalService.create({
      nzClosable: false,
      nzContent: TableBookingTimeConfigModalComponent,
      nzComponentParams: { slotData },
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 650,
    });
  }

  async openCancelBookingModal(data: any): Promise<NzModalRef<any>>  {
    const { CancelBookingModalComponent } = await import(
      /* webpackPrefetch: true */ '../modal/cancel-booking-modal/cancel-booking-modal.component'
    );
    return this._modalService.create({
      nzContent: CancelBookingModalComponent,
      nzClosable: false,
      nzComponentParams: { data },
      nzFooter: null,
      nzWidth: 650,
      nzBodyStyle: {
        background: '#F5F7F9',
        padding: '0',
      },
    });
  }

  async openModifyBookingModal(data: any): Promise<NzModalRef<any>>  {
    const { ModifyBookingModalComponent } = await import(
      /* webpackPrefetch: true */ '../modal/modify-booking-modal/modify-booking-modal.component'
    );
    return this._modalService.create({
      nzContent: ModifyBookingModalComponent,
      nzClosable: false,
      nzComponentParams: { data },
      nzFooter: null,
      nzWidth: 650,
      nzBodyStyle: {
        padding: '0',
      },
    });
  }

  async openCheckinBookingModal(data: any): Promise<NzModalRef<any>>  {
    const { CheckinBookingModalComponent } = await import(
      /* webpackPrefetch: true */ '../modal/checkin-booking-modal/checkin-booking-modal.component'
    );
    return this._modalService.create({
      nzContent: CheckinBookingModalComponent,
      nzComponentParams: { data },
      nzClosable: false,
      nzFooter: null,
      nzWidth: 650,
      nzBodyStyle: {
        background: '#F5F7F9',
        padding: '0',
      },
    });
  }

  async openCalendarBookingModal(data?: any): Promise<NzModalRef<any>>  {
    const { CalendarBookingModalComponent } = await import(
      /* webpackPrefetch: true */ '../modal/calendar-booking-modal/calendar-booking-modal.component'
    );
    return this._modalService.create({
      nzTitle: null,
      nzClosable: false,
      nzContent: CalendarBookingModalComponent,
      nzComponentParams: { data },
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 650,
    });
  }

  async openBookingRequestsModal(modalData): Promise<NzModalRef<any>>  {
    const { BookingRequestsModalComponent } = await import(
      /* webpackPrefetch: true */ '../modal/booking-requests-modal/booking-requests-modal.component'
    );
    return this._modalService.create({
      nzContent: BookingRequestsModalComponent,
      nzClosable: false,
      nzFooter: null,
      nzWidth: 690,
      nzComponentParams: { modalData },
      nzBodyStyle: {
        padding: '0',
      },
    });
  }

  async openRejectedBookingModal(modalData): Promise<NzModalRef<any>>  {
    const { RejectedBookingsModalComponent } = await import(
      /* webpackPrefetch: true */ '../modal/rejected-bookings-modal/rejected-bookings-modal.component'
    );
    return this._modalService.create({
      nzContent: RejectedBookingsModalComponent,
      nzClosable: false,
      nzFooter: null,
      nzComponentParams: { modalData },
      nzWidth: 850,
      nzBodyStyle: {
        background: '#F5F7F9',
        padding: '0',
      },
    });
  }
}
